export const productHoldingData = [
    {
        "company_name":"GARUDA TIMUR PACIFIC",
        "group_company":"GARUDAFOOD",
        "total_assets_under_management":41359405.6000000015,
        "total_credit_limit":0.0,
        "total_cash_loan_limit":0.0,
        "total_non_cash_loan_limit":0.0,
        "total_credit_outstanding":0.0,
        "total_cash_loan_outstanding":0.0,
        "total_non_cash_loan_outstanding":0.0,
        "available_credit_limit":0.0,
        "funding_growth_target_amount_current_fy":10.0,
        "funding_amount_growth_achieved_current_fy":4.0,
        "lending_growth_target_amount_current_fy":50,
        "lending_amount_growth_achieved_current_fy":0,
        "current_account_growth_mtd_percentage":12,
        "current_account_growth_ytd_percentage":12
    },
    {
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD",
        "total_assets_under_management":352904233772.424987793,
        "total_credit_limit":2606100000000.0,
        "total_cash_loan_limit":2606100000000.0,
        "total_non_cash_loan_limit":0.0,
        "total_credit_outstanding":1278412500000.0,
        "total_cash_loan_outstanding":1278412500000.0,
        "total_non_cash_loan_outstanding":0.0,
        "available_credit_limit":1327687500000.0,
        "funding_growth_target_amount_current_fy":1000.0,
        "funding_amount_growth_achieved_current_fy":700.0,
        "lending_growth_target_amount_current_fy":1500,
        "lending_amount_growth_achieved_current_fy":600,
        "current_account_growth_mtd_percentage":12,
        "current_account_growth_ytd_percentage":12
    },
    {
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "total_assets_under_management":18126680335134.49609375,
        "total_credit_limit":99674131006.050201416,
        "total_cash_loan_limit":0.0,
        "total_non_cash_loan_limit":99674131006.050201416,
        "total_credit_outstanding":3545011.2102000001,
        "total_cash_loan_outstanding":0.0,
        "total_non_cash_loan_outstanding":3545011.2102000001,
        "available_credit_limit":99670585994.8399963379,
        "funding_growth_target_amount_current_fy":10000.0,
        "funding_amount_growth_achieved_current_fy":7000.0,
        "lending_growth_target_amount_current_fy":500,
        "lending_amount_growth_achieved_current_fy":400,
        "current_account_growth_mtd_percentage":12,
        "current_account_growth_ytd_percentage":12
    },
    {
        "company_name":"PERUSAHAAN LISTRIK NEGARA, PT (PERSERO)",
        "group_company":"PLN GROUP",
        "total_assets_under_management":2019939.2,
        "total_credit_limit":0.0,
        "total_cash_loan_limit":0.0,
        "total_non_cash_loan_limit":0.0,
        "total_credit_outstanding":0.0,
        "total_cash_loan_outstanding":0.0,
        "total_non_cash_loan_outstanding":0.0,
        "available_credit_limit":0.0,
        "funding_growth_target_amount_current_fy":1.5,
        "funding_amount_growth_achieved_current_fy":1.2,
        "lending_growth_target_amount_current_fy":100,
        "lending_amount_growth_achieved_current_fy":0,
        "current_account_growth_mtd_percentage":9,
        "current_account_growth_ytd_percentage":9
    },
    {
        "company_name":"PT SINARNIAGA SEJAHTERA",
        "group_company":"GARUDAFOOD",
        "total_assets_under_management":1007410387.9000000954,
        "total_credit_limit":0.0,
        "total_cash_loan_limit":0.0,
        "total_non_cash_loan_limit":0.0,
        "total_credit_outstanding":0.0,
        "total_cash_loan_outstanding":0.0,
        "total_non_cash_loan_outstanding":0.0,
        "available_credit_limit":0.0,
        "funding_growth_target_amount_current_fy":1.0,
        "funding_amount_growth_achieved_current_fy":0.5,
        "lending_growth_target_amount_current_fy":50,
        "lending_amount_growth_achieved_current_fy":0,
        "current_account_growth_mtd_percentage":12,
        "current_account_growth_ytd_percentage":12
    },
    {
        "company_name":"PUPUK INDONESIA PERSERO",
        "group_company":"PUPUK INDONESIA",
        "total_assets_under_management":2126329214747.9001464844,
        "total_credit_limit":0.0,
        "total_cash_loan_limit":0.0,
        "total_non_cash_loan_limit":0.0,
        "total_credit_outstanding":0.0,
        "total_cash_loan_outstanding":0.0,
        "total_non_cash_loan_outstanding":0.0,
        "available_credit_limit":0.0,
        "funding_growth_target_amount_current_fy":50.0,
        "funding_amount_growth_achieved_current_fy":12.0,
        "lending_growth_target_amount_current_fy":50,
        "lending_amount_growth_achieved_current_fy":0,
        "current_account_growth_mtd_percentage":6,
        "current_account_growth_ytd_percentage":6
    },
    {
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "total_assets_under_management":1479485754455.8090820312,
        "total_credit_limit":3885499386546.1591796875,
        "total_cash_loan_limit":3369665478074.9599609375,
        "total_non_cash_loan_limit":515833908471.1989746094,
        "total_credit_outstanding":3163917230214.01953125,
        "total_cash_loan_outstanding":2720091410012.8798828125,
        "total_non_cash_loan_outstanding":443825820201.1400146484,
        "available_credit_limit":721582156332.1396484375,
        "funding_growth_target_amount_current_fy":1000.0,
        "funding_amount_growth_achieved_current_fy":300.0,
        "lending_growth_target_amount_current_fy":900,
        "lending_amount_growth_achieved_current_fy":300,
        "current_account_growth_mtd_percentage":11,
        "current_account_growth_ytd_percentage":11
    },
    {
        "company_name":"TUDUNG PUTRA PUTRI JAYA",
        "group_company":"GARUDAFOOD",
        "total_assets_under_management":662848862.2000000477,
        "total_credit_limit":0.0,
        "total_cash_loan_limit":0.0,
        "total_non_cash_loan_limit":0.0,
        "total_credit_outstanding":0.0,
        "total_cash_loan_outstanding":0.0,
        "total_non_cash_loan_outstanding":0.0,
        "available_credit_limit":0.0,
        "funding_growth_target_amount_current_fy":100.0,
        "funding_amount_growth_achieved_current_fy":50.0,
        "lending_growth_target_amount_current_fy":50,
        "lending_amount_growth_achieved_current_fy":0,
        "current_account_growth_mtd_percentage":12,
        "current_account_growth_ytd_percentage":12
    },
    {
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "total_assets_under_management":549497035226.1820068359,
        "total_credit_limit":772398502035.4725341797,
        "total_cash_loan_limit":28076923.0758000016,
        "total_non_cash_loan_limit":772370425112.3967285156,
        "total_credit_outstanding":5830765142488.193359375,
        "total_cash_loan_outstanding":301265384603.333984375,
        "total_non_cash_loan_outstanding":5529499757884.859375,
        "available_credit_limit":-5058366640452.720703125,
        "funding_growth_target_amount_current_fy":500.0,
        "funding_amount_growth_achieved_current_fy":50.0,
        "lending_growth_target_amount_current_fy":50,
        "lending_amount_growth_achieved_current_fy":30,
        "current_account_growth_mtd_percentage":10,
        "current_account_growth_ytd_percentage":10
    }
]